<template>
  <div class="panal mt-20">
    <div class="panal-header">Preferences </div>

    <div class="table-responsive p-3">
      <table class="table table-hover  table-bordered">
        <thead class="thead-light">
          <tr>
            <th scope="col" colspan="2" >Prefrence</th>
            <th scope="col" >Campus</th>
            <th scope="col" >Branch</th>
            <th scope="col" >Enrollment Type</th>
            <th scope="col" >Semester</th>
            <th scope="col" >Delete</th>
          </tr>
        </thead>
        <tbody>
           <tr v-if="empty">
            <td colspan="8"> No Data </td>
          </tr>
          <tr v-else v-for="pref in ApplicantPreferencesList " v-bind:key="pref.serial">
            <td colspan="2">{{pref.PreferenceNameEN}}</td>
            <td>{{pref.BrancheNameEN}}</td>
            <td>{{pref.FacultyNameEN}}</td>
            <td>{{pref.ApplicantStatusEN}}</td>
            <td>{{pref.SemesterName}}</td>
          <td><button class="btn btn-danger"  @click="filedelete(pref.serial)"><i class=""></i>delete</button></td>

          </tr>
         
        
          <tr class="table-borderless">
            <td align="left" colspan="4">
              <span class="text-left">Prefrence Order</span>
              <select class="form-control w-100 su-border" id="exampleFormControlSelect1" v-validate="'required|excluded:0'" name="Prefrence"
                v-model="ApplicantPreferences.PreferenceID" v-b-tooltip.hover title="Prefrence Order">
                <option selected value="0">choose</option>
                <option v-for="Pref in PreferencesList" :value="Pref.PreferenceSerial"
                  v-bind:key="Pref.PreferenceSerial">{{Pref.PreferenceNameEN}}</option>
              </select>
                    <div v-if="submitted && errors.has('Prefrence')" class="alert-danger">{{errors.first('Prefrence')}}</div>

            </td>
            <td align="left" colspan="3"> 
              <span>Campus</span>
              <select class="form-control w-100 su-border"  v-validate="'required|excluded:0'" name="Campus"
                v-model="ApplicantPreferences.CampusId"  @change="getFaculty()" v-b-tooltip.hover title="Campus">
                <option selected value="0">Choose</option>
                <option    v-for="camp in Campus" :value="camp.BranchSerial" v-bind:key="camp.BranchSerial">
                  {{camp.BrancheNameEN}}</option>


              </select>
                                  <div v-if="submitted && errors.has('Campus')" class="alert-danger">{{errors.first('Campus')}}</div>

            </td>
            
          </tr>
          <tr class="table-borderless">
            <td align="left" colspan="4">
              <span>Faculty</span>
              <select class="form-control w-100 su-border" id="exampleFormControlSelect3" v-validate="'required|excluded:0'" name="Faculty"
                v-model="ApplicantPreferences.FacultyBranchID" v-b-tooltip.hover title="Faculty">
                <option selected value="0">choose</option>
                <option  v-for="fac in Faculty" :value="fac.FacultyBranchID" v-bind:key="fac.FacultyBranchID">
                  {{fac.FacultyNameEN}}</option>

              </select>
                                  <div v-if="submitted && errors.has('Faculty')" class="alert-danger">{{errors.first('Faculty')}}</div>

            </td>
            <td align="left" colspan="2">
              <span>Entrollment Type</span>
              <select class="form-control w-100 su-border"  v-validate="'required|excluded:0'" name="Entrollment"
                v-model="ApplicantPreferences.EnrollmentTypeID" v-b-tooltip.hover title="Entrollment Type">
                <option selected value="0">choose</option>
                <option v-for="enrol in EnrollmentType" :value="enrol.Serial" v-bind:key="enrol.Serial">
                  {{enrol.ApplicantStatusEN}}</option>

              </select>
                                  <div v-if="submitted && errors.has('Entrollment')" class="alert-danger">{{errors.first('Entrollment')}}</div>

            </td>
            <td  style="text-align: left;">
              <br />
          <button type="button" class="btn btn-block btn-primary btn-sm" id="addrow"  @click="handlePreferences()" :disabled="loading">
                       <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                      Add Preference</button>
            </td>
          </tr>
        </tbody>
      </table>
   <div v-if="message && flag!= 1" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>


    </div>



  </div>


</template>

<script>
  import {
    EnrollmentType,
    ApplicantPreferences,
    PreferencesList,
    Faculty,
    Campus,
    ApplicantPreferencesList
  } from '../../models/Applicant';
  import ApplicantServices from '../../services/Applicant/Applicant.service';
  import ApplicantDataServices from '../../services/Applicant/ApplicantData.services';
  export default {
    name: 'Preferences',
    data() {
      return {
        ApplicantPreferencesList: new ApplicantPreferencesList('', '', '', '', '', '', '', '','',''),
        EnrollmentType: new EnrollmentType('', '', '', ''),
        ApplicantPreferences: new ApplicantPreferences(0, 0, 0, 0, 0),
        PreferencesList: new PreferencesList('', '', ''),
        Faculty: new Faculty('', '', ''),
        Campus: new Campus('', '', ''),
        submitted: false,
        loading: false,
        successful: false,
        message: '',
        avilabelSemester: [],
        flag:'',
        empty:false
      }
    },
    computed: {
      currenUser() {
        return this.$store.state.auth.user
      },
      reviewApplication(){
       return  this.$store.state.auth.renderReview 

        
       }
    },
    mounted() {
      ApplicantServices.GetBranchesAPI().then(Response => {
        this.Campus = Response.data
      }, error => {
        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();
      });
      ApplicantServices.GetEnrollmentStatus().then(Response => {
        this.EnrollmentType = Response.data
      }, error => {
        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();
      });
      ApplicantServices.GetlistOfPreferences().then(Response => {
        this.PreferencesList = Response.data
      }, error => {
        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();
      });
      ApplicantServices.GetActiveAvailableSemester().then(Response => {
        this.avilabelSemester = Response.data
      }, error => {
        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();
      });
      ApplicantDataServices.GetlistOfApplicantPreferences(this.currenUser).then(Response => {
       this.empty=false

        this.ApplicantPreferencesList = Response.data
      }, error => {
         
                   this.empty = true
                 
          //this.flag = 1
          //this.empty =false
          this.successful =false
        this.ApplicantPreferencesList = ('', '', '', '', '', '', '', '','','')
        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();
          if(error.response.status == 404) this.message =''
      // eslint-disable-next-line no-unused-vars
      }).catch(error => {
         this.ApplicantPreferencesList = ('', '', '', '', '', '', '', '','','')
        
          this.message='No data found'
          this.successful= false
      });

    },
    methods: {

      getFaculty() {
        
        ApplicantServices.GetActiveFacultyBranchesAPI(this.ApplicantPreferences.CampusId).then(Response => {
         let List = Response.data
         this.Faculty =   List.filter(x=>x.FacultyBranchID !=0)
        }, error => {
        
          this.message =
            (error.response && error.response.data && error.response.data.Message) ||
            error.message ||
            error.toString();
        });
      },
      handlePreferences(){
        this.submitted =true
         this.$validator.validate().then(isValid => {
          if (isValid) {
             this.$store.dispatch('auth/Review', this.reviewApplication+1 )
          this.loading =true
        this.ApplicantPreferences.ApplicantID = this.currenUser.UserIDSerial ;

        ApplicantDataServices.PostlistOfApplicantPreferences(this.ApplicantPreferences).then(Response => {
         this.successful = true
           this.loading =false
         this.message =   Response.data
          ApplicantDataServices.GetlistOfApplicantPreferences(this.currenUser).then(Response => {
          this.empty=false

        this.ApplicantPreferencesList = Response.data
        this.$store.dispatch('auth/Review', this.reviewApplication+1 )
      })
        }, error => {
                 this.successful = false
          this.loading =false

          this.message =
            (error.response && error.response.data && error.response.data.Message) ||
            error.message ||
            error.toString();
        });
          }})
      },
      filedelete(Serial){
                   this.$store.dispatch('auth/Review', this.reviewApplication+1 )

  ApplicantDataServices.ApplicantPreferenceDelete(this.currenUser.UserIDSerial,Serial).then(Response =>{
          this.message=Response.data
          this.successful =true
           this.$store.dispatch('auth/Review', this.reviewApplication+1 )
         this.ApplicantPreferencesList = this.ApplicantPreferencesList.filter(files => files.serial != Serial)
          this.empty = false
        }, error => {
          this.empty =false
          this.successful =false
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            });    
}
    },
  }
</script>

<style scoped>

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
    border: 1px solid #d4d4d4;
padding:0px 0px 20px 0px;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;
}
  .panal-header {
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
    width: 50%;
    /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
  }

  .mt-20 {
    margin-top: 20px;
  }

  .mt-40 {
    margin-top: 40px;
  }

  th {
    font-weight: bold;
  }

  .su-border {
    border-color: #3D8FE3 !important;
    background: #F1F9FF !important;
  }
  .table .thead-light th {
    color: #495057;
    background-color: #e9ecef;
    border-color: #dee2e6;
    font-size: 13px;
}
.table th, .table td {
      font-size: 15px;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
</style>